import {
  Box,
} from "@chakra-ui/react";
import { UseFormReturn } from "react-hook-form";
import { useCallback } from "react";
import TimezoneSelectField from "components/FormElements/Fields/SelectFields/TimezoneSelectField";
import { convertToLocalDate, convertToLocalTimeString } from "helpers/time";
import { GreyBlackLabel } from "components/DataDisplay/GreyBlackField";
import { longAttributeStyles } from "components/DataDisplay/styles";
import { ITimezoneOption } from "react-timezone-select";

interface SingleTimezoneSelectFieldProps {
  datetimeFieldName: string;
  form: UseFormReturn<any>;
}

export default function SingleTimezoneSelectField({ form, datetimeFieldName, labelProps = {}, ...rest }: SingleTimezoneSelectFieldProps) {
  const {
    control,
    formState: { errors },
    setValue,
    getValues,
  } = form;
  const timezoneFieldName = "timezone";
  const dateFieldName = `local.${datetimeFieldName}.date`;
  const timeFieldName = `local.${datetimeFieldName}.timeOfDay`;

  const handleTimeZoneChange = useCallback(
    (newTimeZone: ITimezoneOption) => {
      if (newTimeZone) {
        const [fieldDateTime] = getValues([datetimeFieldName]);
        if (fieldDateTime) {
          const newLocalDate = convertToLocalDate(fieldDateTime, newTimeZone?.value || "UTC");
          const newLocalTime = convertToLocalTimeString(fieldDateTime, newTimeZone?.value || "UTC");
          setValue(dateFieldName, newLocalDate, { shouldDirty: true });
          setValue(timeFieldName, newLocalTime, { shouldDirty: true });
          setValue(timezoneFieldName, newTimeZone.value, { shouldDirty: true });
        } else {
          console.error(`Cannot find datetime for field ${datetimeFieldName}`);
        }
      }
    },
    [getValues, datetimeFieldName, setValue, dateFieldName, timeFieldName],
  );

  return (
    <Box width="350px">
      <TimezoneSelectField
        label={<GreyBlackLabel label="Timezone" {...labelProps} />}
        name={timezoneFieldName}
        control={control}
        errors={errors}
        size="sm"
        formFieldProps={{ sideLayout: true, labelProps: { display: "flex", alignItems: "flex-end", ...longAttributeStyles.labelContainerProps } }}
        onChange={(newTimeZone: ITimezoneOption) => {
          handleTimeZoneChange(newTimeZone);
        }}
        sx={{
          padding: "0",
          height: "32px !important",
          paddingTop: "0 !important",
          fontSize: "14px",
        }}
        {...rest}
      />
    </Box>
  );
}
